import React, {Component} from 'react';
import {SelectionModes} from '@blueprintjs/table/lib/esm/index';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import MUIDataTable from 'mui-datatables';
import toastr from "toastr";
import _ from 'lodash';
import $ from 'jquery';

import * as authService from "../../services/authService";
import http from "../../services/httpService";

import {paginate} from '../../components/utils/paginate_posts'
import Pagination from '../../components/common/Pagination'
import SearchBox from '../../components/common/SearchBox'
import ItemsPerPage from '../common/ItemsPerPage';
import Theme from '../common/MuiTheme';
import { optionsTimeSpan } from '../constants/constants';
import AddContactModal from '../modals/AddContactModal';
import DeleteSubscribersModal from '../modals/DeleteSubscribersModal';
import ChartLoader from '../utils/chart-loader';
import CustomToolbarSelect from './contacts/CustomToolbarSelect';

import SubscribersTable from './subscribers/SubscribersTable'
import PushSubscribersTable from './subscribers/PushSubscribersTable'

import Loader from '../utils/loader'
import ReactGA from "react-ga";
import { getCurrentUserId, getJwt } from '../../services/authService';
import {
    Button,
    Icon,
    Intent,
    Menu,
    MenuItem,
    Popover,
    PopoverInteractionKind,
    Position,
    Tag
} from '@blueprintjs/core';
import {Select} from "@blueprintjs/select";
import {
    Cell,
    Column,
    ColumnHeaderCell,
    Table,
    TableLoadingOption
} from "@blueprintjs/table";
import {MultiSelect} from "@blueprintjs/select";
import TableNoData from "../common/TableNoData";
import sizeMe from 'react-sizeme';
import {Route, Switch, Redirect, NavLink, Link} from 'react-router-dom';


class Subscribers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasInitialContent: false,

            subscribers: [],
            total_subscribers: 0,
            max_subscribers: 0,
            push_subscribers: [],
            pageSize: 10,
            currentPage: 1,
            data: '',
            sortColumn: {
                path: "updated_at",
                order: "asc"
            },
            tags: this.props.tags,
            searchQuery: "",
            type_of_subscription: localStorage.getItem('fb_subs_type') || "all",
            sub_type: true,
            selected_source: props.selected_source,
            loader: false,
            immediate: '',
            daily: '',
            weekly: '',
            unsubscribed: '',
            fullWidth: false,
            searched_subscribers: [],
            last_page: false,
            last_page_size: '',
            forceTableRerender: true,
            subscription_filter: '',
            checkedSubscribers: [],
            //tags dropdown states
            selectedTags: [],
            createTag: '',
            bulkTags: '',
            searchedBulkTags: '',
            createTagString: '',
            bulkLoader: false,
            selectedType: localStorage.getItem('main_subs') || 'fb',
            selectAllChecked: false,
            sort: '',
            order: '',
            lastColumnWidth: 500,
            deleteSubscribersModalVisible: false,
            bulkIsOpen: undefined,
            createTagLoader: false,
            rowsSelected: []
        };

        toastr.options = {
            closeButton: true,
            positionClass: "toast-bottom-full-width",
            showDuration: "300",
            hideDuration: "1000",
            timeOut: "8000",
            extendedTimeOut: "1000",
        };
    }

    


    async componentDidMount() {
        //ReactGA.pageview(window.location.pathname + window.location.search);

        // this.updateTableWidth();
        // this.setState({columnsWidth : columnsWidth});
        


        try {
            this.setState({loader: true});
            const selected_source = this.props.selected_source || JSON.parse(localStorage.source_clicked || this.state.selected_source);
            const pageSize = this.state.pageSize;
            if (selected_source) {

                const result = await http.get('api/feed/' + selected_source + '/subscribers/fb/page_size/' + pageSize, {headers: {authorization: authService.getJwt()}});

                const data = result.data;
                const total_subscribers = data.total_subscribers;
                const lastPageSize = total_subscribers % pageSize;
                const currentPage = this.state.currentPage;
                let numberOfPages = Math.ceil(total_subscribers / pageSize);
                if (numberOfPages === 0) {
                    numberOfPages = 1
                }
                // console.log('data', data);
                // console.log('total subscribers:', total_subscribers);
                // console.log('last page size: ', lastPageSize);
                // console.log('current page: ', currentPage);
                // console.log('number of pages: ', numberOfPages);


                if (!data) {
                    toastr.error("User id does not match. :(  Please log in again.");
                    this.props.history.push('/logout');
                }


                    this.setState({
                        subscribers: data.subscribers.data,
                        searched_subscribers: data.subscribers.data,
                        total_subscribers: data.total_subscribers,
                        max_subscribers: data.total_subscribers,
                        data: data,
                        last_page: currentPage === numberOfPages,
                        last_page_size: lastPageSize,
                        // loader: false
                    });

            }
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
        if (this.state.selectedType === 'wp') {
            if (document.querySelector("#webpush-button")) {
                await document.querySelector("#webpush-button").click();
            }
            this.props.history.push('/subscribers/web-push')
        } else {
            if (document.querySelector("#" + this.state.type_of_subscription)) {
                await document.querySelector("#" + this.state.type_of_subscription).click();
            }
            this.props.history.push('/subscribers/messenger')
        }
        let {
            subscribers: subscribersAll,

            //push_subscribers: subscribersPush
        } = this.state;

        let filtered = subscribersAll;
        let immediate = '';
        let daily = '';
        let weekly = '';
        let unsubscribed = '';
        //console.log('response data: ', data);
        if (this.state.data) {

            immediate = this.state.data.subscribers_totals_selected_source.subscribers_count_immediate_total - this.state.data.subscribers_totals_selected_source.subscribers_count_wp_total;

            daily = this.state.data.subscribers_totals_selected_source.subscribers_count_daily_total;

            weekly = this.state.data.subscribers_totals_selected_source.subscribers_count_weekly_total;

            unsubscribed = this.state.data.subscribers_totals_selected_source.subscribers_count_fb_unsubscribed;

        }
        //console.log('immediate:', immediate);

        if (this.state.searchQuery) {
            if (this.state.sub_type) {
                filtered = subscribersAll.filter(m => m.subscriber_name.toLowerCase().includes(this.state.searchQuery.toLowerCase()));
            }
        }


        //const sorted = _.orderBy(filtered, [this.state.sortColumn.path], [this.state.sortColumn.order]);
        const subscribers = paginate(filtered, this.state.currentPage, this.state.pageSize);

        //setting cols width

        //console.log('window innerWidth: ', window.innerWidth);
        this.recalculateColsWidth(1120);
        // this.updateTableWidth();
        await this.setState({
            subscribers: subscribers,
            searched_subscribers: subscribers,
            daily: daily,
            weekly: weekly,
            unsubscribed: unsubscribed,
            immediate: immediate,
            loader: false
            //bulkTags
        })
    }

    deleteSubscribers = async (e) => {
        const deleteSubscribersData = {
            deleteSubscriberIds: this.state.checkedSubscribers,
            pageSize: this.state.pageSize,
            currentPage: this.state.currentPage,
            subscribersType: this.state.selectedType
        };
        //console.log('Subscribers - deleteSubscribers e: ', e);
        // console.log('Subscribers - deleteSubscribers data: ', deleteSubscribersData)
        this.setState({deleteSubscribersModalVisible: true, bulkIsOpen: undefined})
        // this.props.openModal(e, deleteSubscribersData)
    }

    recalculateColsWidth = async (tableTotalWidth) => {
        let containerWidth = this.props.size.width;
        let lastWidth = (containerWidth - tableTotalWidth) > 0 ? (containerWidth - tableTotalWidth) : 150;
        // console.log('recalculateColsWidth: ', containerWidth, tableTotalWidth, lastWidth)
        if ((this.state.lastColumnWidth !== lastWidth) && (lastWidth > 0) && containerWidth > 0) {
            await this.setState({lastColumnWidth: lastWidth > 150 ? lastWidth : 150})
            await this.setState({forceTableRerender: true})
            await this.setState({forceTableRerender: false})
        }
    }

    //write same function for webpush subscribers table




    componentDidUpdate=async()=> {
        if (this.state.selected_source !== this.props.selected_source || this.props.deleteSubscribersIndicator !== this.props.deleteSubscribersIndicator) {

            await this.setState({
                loader: true,
                selected_source: this.props.selected_source,
                type_of_subscription: "all"
            });
            //console.log('selectedPage: ', this.state.selectedPage);
            this.handlePageChange(this.state.selectedPage, this.props.selected_source, "all");

            let selected_source = this.props.selected_source || JSON.parse(localStorage.source_clicked || this.state.selected_source);
            let pageSize = this.state.pageSize;

            try {

                let result = await http.get('api/feed/' + selected_source + '/subscribers/fb/page_size/' + pageSize, {headers: {authorization: authService.getJwt()}});

                let data = await result.data;
                let {
                    subscribers: subscribersAll,
                    //push_subscribers: subscribersPush
                } = this.state;

                let filtered = subscribersAll;
                let immediate = '';
                let daily = '';
                let weekly = '';
                let unsubscribed = '';
                //console.log('change data:', data);

                if (data) {
                    daily = data.subscribers_totals_selected_source.subscribers_count_daily_total;

                    weekly = data.subscribers_totals_selected_source.subscribers_count_weekly_total;

                    unsubscribed = data.subscribers_totals_selected_source.subscribers_count_fb_unsubscribed;

                    immediate = this.state.data.subscribers_totals_selected_source.subscribers_count_immediate_total - this.state.data.subscribers_totals_selected_source.subscribers_count_wp_total;


                }

                if (this.state.searchQuery) {
                    if (this.state.sub_type) {
                        filtered = await subscribersAll.filter(m => m.subscriber_name.toLowerCase().includes(this.state.searchQuery.toLowerCase()));
                    }
                }


                const sorted = _.orderBy(filtered, [this.state.sortColumn.path], [this.state.sortColumn.order]);
                const subscribers = paginate(sorted, this.state.currentPage, this.state.pageSize);

                await this.setState({
                    subscribers: subscribers,
                    searched_subscribers: subscribers,
                    daily: daily,
                    weekly: weekly,
                    unsubscribed: unsubscribed,
                    immediate: immediate,
                    data: data,
                    loader: false,
                    checkedSubscribers: []
                })

            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }
    }

    handleChangeSelectSearch = async (selectedParam, item = null) => {
        let value = '';
        if (selectedParam !== '') {
            const target = selectedParam.target;

            //console.log('selectedParam: ', selectedParam);
            // ReactGA.event({
            //     category: 'Click',
            //     action: 'Subscribers - Items shown per page',
            //     userId: getCurrentUserId(),
            //     label: target.id,
            //     nonInteraction: true
            // });
            value = target.id;
        } else {
            value = item.value
        }

        const pageSize = Number(value);
        const selected_source = JSON.parse(localStorage.source_clicked) || this.state.selected_source || this.props.selected_source;
        let type = this.state.sub_type ? "fb" : "wp";
        //console.log('page size:', pageSize);
        let searchedSubsLength = await this.state.searched_subscribers.length;
        let indicator = await searchedSubsLength / pageSize;

        //console.log('searchedSubsLength:', searchedSubsLength);
        //console.log('indicator - items number before:', indicator);
        if (indicator % 1 !== 0 && indicator > 1) {
            indicator = await Math.ceil(indicator)
        }
        //console.log('indicator - items number after:', indicator);
        let lastPageSize = await searchedSubsLength % this.state.pageSize;
        let lastPage = false;

        if (lastPageSize === 0) {
            lastPageSize = await this.state.pageSize
        }
        if (indicator === this.state.currentPage || indicator < 1) {
            lastPage = true
        }

        //console.log('change page - last page size:', lastPageSize);

        await this.setState({
            pageSize: pageSize,
            last_page: lastPage,
            last_page_size: lastPageSize
        });

        this.handlePageChange(this.state.currentPage, selected_source, '', pageSize);
    };

    handleClick = (subscriber) => {
        this.props.history.push("/dashboard");
    };


    switchTypeOfSubscription = async (type_of_subscription) => {
        type_of_subscription.preventDefault()

        this.setState({

            type_of_subscription: type_of_subscription.target.id,
            currentPage: 1,
            checkedSubscribers: []
        });

        //document.querySelector('.table-checkmark:after').css('opacity','0')
        try {
            this.setState({loader: true});
            const selected_source = this.props.selected_source || JSON.parse(localStorage.source_clicked) || this.state.selected_source;
            const pageSize = this.state.pageSize;
            // ReactGA.event({
            //     category: 'Click',
            //     action: 'Dashboard Subscribers Filter',
            //     userId: getCurrentUserId(),
            //     label: type_of_subscription.target.id,
            //     nonInteraction: true
            // });

            const type = type_of_subscription.target.id || "all";
            localStorage.setItem('fb_subs_type', type);
            let type_to_get = "fb";
            if (type === "daily") {
                type_to_get = "fb_daily";
            } else if (type === "immediate") {
                type_to_get = "fb_immediate";
            } else if (type === "weekly") {
                type_to_get = "fb_weekly";
            } else if (type === "unsubscribed") {
                type_to_get = "fb_unsubscribed";
            } else if (type === 'wp') {
                type_to_get = 'wp'
            }

            const result = await http.get('api/feed/' + selected_source + '/subscribers/' + type_to_get + '/page_size/' + pageSize, {headers: {authorization: authService.getJwt()}});

            const data = result.data;
            let filtered = await data.subscribers.data;
            if (type !== 'unsubscribed' && type !== 'all') {
                filtered = filtered.filter(f => f.unsubscribe !== 1)
            }
            let indicator = filtered.length / this.state.pageSize;
            //console.log('indicator:', indicator);
            if (indicator % 1 !== 0) {
                indicator = Math.ceil(indicator)
            }
            let lastPageSize = filtered.length % this.state.pageSize;
            if (lastPageSize === 0) {
                lastPageSize = this.state.pageSize
            }
            if (filtered.length === 0) {
                indicator = 1;
                lastPageSize = 0;
            }

            //  console.log('type of subscription:', type)
            await this.setState({
                last_page_size: lastPageSize,
                last_page: indicator === 1,
                subscribers: filtered,
                searched_subscribers: filtered,
                total_subscribers: data.total_subscribers,
                loader: false,
                //subscription_filter: type_of_subscription.target.id
            });
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
    };

    handleTagSearch = async (query) => {
        //console.log('tag search query: ', query);
        let bulkTags = await this.state.bulkTags
        let filtered = '';
        query = query.toLowerCase()
        if (query !== '') {
            //console.log('tag search query: ', query);
            filtered = await bulkTags.filter(tag => tag.name.toLowerCase().includes(query))
        } else {
            filtered = await bulkTags
        }
        // console.log('filtered tags: ', filtered);
        await this.setState({
            searchedBulkTags: filtered,
            createTagString: query
        });

    };

    handleSearch = async (query) => {
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Subscribers - Search',
        //     userId: getCurrentUserId(),
        //     label: query,
        //     nonInteraction: true
        // });
        //console.log('search handled:', query);
        //console.log('subscribers:', this.state.subscribers);
        let filtered = '';
        if (query !== '') {
            query = query.toLowerCase();
            //console.log('type of subscription:', this.state.type_of_subscription);
            //console.log('search: ', query);
            //&& sub.type_of_subscription === this.state.type_of_subscription
            let filteredSubs = this.state.searched_subscribers;
            if (this.state.type_of_subscription !== 'all') {
                filteredSubs = filteredSubs.filter(sub => sub.type_of_subscription === this.state.type_of_subscription)
            }
            filtered = await filteredSubs.filter(sub => sub.subscriber_name.toLowerCase().includes(query));
        } else {
            //console.log('search: ', query);
            document.querySelector('#subs-search').blur();
            filtered = await this.state.searched_subscribers

        }

        let lastPage = false;
        let indicator = filtered.length / this.state.pageSize;
        //console.log('indicator:', indicator);
        if (indicator % 1 !== 0 && indicator > 1) {
            indicator = Math.ceil(indicator)
        }
        let lastPageSize = await filtered.length % this.state.pageSize;
        if (lastPageSize === 0) {
            lastPageSize = this.state.pageSize
        }
        if (filtered.length === 0) {
            lastPage = true;
            lastPageSize = 0;
        }
        //console.log('indicator after: ', indicator);
        //console.log('last page size - search: ', lastPageSize);


        if (indicator === this.state.currentPage || indicator < 1) {
            lastPage = true
        }
        await this.setState({
            searched_subscribers: filtered,
            searchQuery: query,
            currentPage: this.state.currentPage,
            last_page: lastPage,
            last_page_size: lastPageSize

        });


    };

    logSearch = query => {

        //console.log('search logged:', query);
        if (this.state.fullWidth === false) {
            this.setState({fullWidth: true})
        } else {
            //this.setState({fullWidth: false});
            document.querySelector('.subscribers-search').value = '';
        }

    };

    handlePageChange = async (page, src = this.state.selected_source, type_of_sub = null, pageSize = this.state.pageSize) => {


        this.setState({
            currentPage: page,
        });

        try {
            await this.setState({loader: true});
            const selected_source = await src || JSON.parse(localStorage.source_clicked) || this.state.selected_source;

            let type = this.state.type_of_subscription;
            //const {type_of_subscription} = type_of_sub ? {type_of_sub} : this.state;

            //let type_of_subscription = '';
            // this.state.type_of_subscription ? type_of_subscription = this.state.type_of_subscription : type_of_subscription = type;

            let type_to_get = '';

            if (type === "daily") {
                type_to_get = "fb_daily";
            } else if (type === "immediate") {
                type_to_get = "fb_immediate";
            } else if (type === "weekly") {
                type_to_get = "fb_weekly";
            } else if (type === "unsubscribed") {
                type_to_get = "fb_unsubscribed";

            } else {
                type_to_get = 'fb'
            }
            if (this.state.selectedType === 'wp') {
                type_to_get = 'wp'
            }
            //   console.log('sub_type:', this.state.sub_type);
            //   console.log('type_of_subscription:', type_of_subscription)
            this.props.loadingSourceChange(true);

            const result = await http.get('api/feed/' + selected_source + '/subscribers/' + type_to_get + '/page_size/' + pageSize + '?page=' + this.state.currentPage + '&sort=' + this.state.sort + '&order=' + this.state.order,
                {headers: {authorization: authService.getJwt()}});
            const data = await result.data;
            this.props.loadingSourceChange(false);
            let filtered = data.subscribers.data;
            //console.log('subs filter:', this.state.subscription_filter)
            // if (this.state.subscription_filter !== '') {
            //     filtered = data.subscribers.data.filter(s => s.type_of_subscription === this.state.subscription_filter);
            // }

            //console.log('type of subscription: ', type);


            let indicator = this.state.max_subscribers / pageSize;
            let searchedSubsLength = await filtered.length;
            //console.log('searchedSubsLength:', searchedSubsLength);
            //console.log('indicator - page before:', indicator);
            if (indicator % 1 !== 0) {
                indicator = Math.ceil(indicator)
            }
            //console.log('indicator - page after:', indicator);
            let lastPageSize = searchedSubsLength % this.state.pageSize;
            if (lastPageSize === 0) {
                lastPageSize = this.state.pageSize
            }
            //console.log('change page - last page size:', lastPageSize);

            this.setState({
                subscribers: data.subscribers.data,
                searched_subscribers: filtered,
                total_subscribers: data.total_subscribers,
                max_subscribers: data.total_subscribers,
                last_page_size: lastPageSize,
                last_page: indicator === this.state.currentPage

            });
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
        this.setState({loader: false});
    };

    toggleSubscribersType = async (event) => {

        const {id} = event.target;
        let btn = ''
        if (id === "webpush-button") {
            btn = 'webpush'
        } else {
            btn = 'facebook messenger'
        }
        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Subscribers - toggle subscribers type: ' + {btn},
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });
        let type = "fb";
        if (id === "webpush-button") {
            type = "wp";
            await this.setState({
                sub_type: false,
                selectedType: 'wp',
                checkedSubscribers: [],
                selectedTags: []
            });
            localStorage.setItem("main_subs", 'wp');
            this.props.history.push('/subscribers/web-push')
        } else {
            this.setState({
                sub_type: true,
                selectedType: 'fb',
                checkedSubscribers: [],
                selectedTags: []
            });

            await this.setState({type_of_subscription: "all"});
            localStorage.setItem("main_subs", 'fb');
            this.props.history.push('/subscribers/messenger');
            document.querySelector("#" + this.state.type_of_subscription).click();

        }

        try {
            this.setState({
                subscribers: [],
                searched_subscribers: [],
                total_subscribers: 0,
                loader: true
            });
            const selected_source = await this.props.selected_source || JSON.parse(localStorage.source_clicked) || this.state.selected_source;
            const pageSize = this.state.pageSize;
            const result = await http.get('api/feed/' + selected_source + '/subscribers/' + type + '/page_size/' + pageSize, {headers: {authorization: authService.getJwt()}});
            const data = result.data;

            if (!data) {
                toastr.error("User id does not match. :(  Please log in again.");
                this.props.history.push('/logout');
            }
            //alert(type);
            this.setState({
                subscribers: data.subscribers.data,
                searched_subscribers: data.subscribers.data,
                total_subscribers: data.total_subscribers,
                loader: false
            });
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);
                this.props.history.push('/logout');
            }
        }


        this.setState({
            currentPage: 1,

        })
    };

    removeElement(array, elem) {
        let index = array.indexOf(elem);
        if (index > -1) {
            array.splice(index, 1);
        }
    }


    handleCheck = async (rowIndexes) => {
        // let checkedSubscribers = this.state.checkedSubscribers;

        //console.log('checked subscribers initial:', checkedSubscribers);
        // console.log('rowIndex:', rowIndex);
        // console.log('sub:', this.state.searched_subscribers[rowIndex]);

        // let checkedSub = this.state.searched_subscribers[rowIndex].id;
        //console.log('checked sub id: ', checkedSub)
        // if (checkedSubscribers.includes(checkedSub)) {
        //     await this.removeElement(checkedSubscribers, checkedSub);
        // } else {
        //     checkedSubscribers = [...checkedSubscribers, checkedSub];
        // }
        //console.log('checked subscribers:', checkedSubscribers);

        let checkedSubscribers = [];
        rowIndexes.map(index => checkedSubscribers.push(this.state.searched_subscribers[index].id))

        this.setState({checkedSubscribers})
        //console.log('newTag', newTag);
        let allTags = [...this.props.tags];
        let bulkTags = [];

        allTags.map(
            tag => {
                let newTag = {
                    id: tag.id,
                    name: tag.tag,
                    subsCount: 0,
                    checkedSubsWithoutTag: []
                };
                bulkTags = [...bulkTags, newTag]
            }
        );

        //let checkedSubs = await [...this.state.checkedSubscribers];
        //console.log('checked subs:', checkedSubscribers);
        //console.log('bulkTags let:', bulkTags);

        //console.log('tags:', oldTags);
        checkedSubscribers.map(checkedSub => {
                let fullCheckedSub = this.state.searched_subscribers.filter(sub => sub.id === checkedSub);
                //console.log('full checked sub', fullCheckedSub);
                let checkedSubTags = fullCheckedSub[0].tags
                //console.log('checked sub tags:', checkedSubTags)
                allTags.map(tag => {


                        // console.log('checked subscriber: ', checkedSub)
                        const matchedTags = checkedSubTags.filter(subTag => subTag.tag === tag.tag);

                        //if checked user has tags
                        if (matchedTags.length > 0) {
                            let specificTag = bulkTags.find(bulkTag => bulkTag.name === tag.tag);
                            //console.log('specific tag:',specificTag);
                            specificTag.subsCount = specificTag.subsCount + 1;
                            let otherTags = bulkTags.filter(bulkTag => bulkTag.name !== tag.tag);
                            otherTags = [...otherTags, specificTag];
                            bulkTags = otherTags;
                            //console.log('bulk tags after all:', bulkTags);
                        }
                        //if checked user doesn't have tags
                        else {
                            //console.log('doesnt have tag: ', tag.tag)
                            let specificTag = bulkTags.find(bulkTag => bulkTag.name === tag.tag);
                            let otherTags = bulkTags.filter(bulkTag => bulkTag.name !== tag.tag);
                            specificTag.checkedSubsWithoutTag.push(checkedSub);
                            otherTags = [...otherTags, specificTag];
                            bulkTags = otherTags;

                        }
                    }
                );

            }
        );
        //console.log('bulkTags:', bulkTags);
        await this.setState({checkedSubscribers, bulkTags, searchedBulkTags: bulkTags});

    };

    addDefaultSrc = (ev) => {
        ev.target.src = 'https://4.bp.blogspot.com/-zsbDeAUd8aY/US7F0ta5d9I/AAAAAAAAEKY/UL2AAhHj6J8/s640/facebook-default-no-profile-pic.jpg';
    }

    tagSelect = async (item) => {
        //console.log('tag selected');
        let selected_source = this.state.selected_source;
        let pageSize = this.state.pageSize;
        let currentPage = this.state.currentPage;

        const type = this.state.type_of_subscription || "all";
        let type_to_get = ''
        if (this.state.selectedType === 'fb') {

            type_to_get = "fb";
            if (type === "daily") {
                type_to_get = "fb_daily";
            } else if (type === "immediate") {
                type_to_get = "fb_immediate";
            } else if (type === "weekly") {
                type_to_get = "fb_weekly";
            } else if (type === "unsubscribed") {
                type_to_get = "fb_unsubscribed";
            }
        } else {
            type_to_get = 'wp'
        }

        let selectedTagsIds = [];
        //console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;


        //console.log('selected tags ids:', selectedTagsIds);
        if (selectedTags.includes(item) === false) {

            selectedTags.push(item);
            await this.setState({selectedTags: selectedTags});
        } else {
            const newTags = await selectedTags.filter(t => t !== item);
            await this.setState({selectedTags: newTags})
        }

        this.state.selectedTags.map(tag => {
            selectedTagsIds = [...selectedTagsIds, tag.id]
        });


        //console.log('selected tags ids - select:', selectedTagsIds);

        // console.log('tags select end')

        if (selectedTagsIds.length !== 0) {
            try {


                let result = await http.post('api/source/' + selected_source + '/filter_subscriber_tags/type/' + type_to_get + '/page_size/' + pageSize + '?page=' + currentPage
                    , {
                        tag_ids: selectedTagsIds
                    },
                    {
                        headers: {
                            authorization: authService.getJwt()
                        }
                    }
                );
                let lastPage = false;

                //console.log('select item result:', result);
                let indicator = result.data.subscribers.data.length / this.state.pageSize;
                //console.log('indicator:', indicator);
                if (indicator % 1 !== 0) {
                    indicator = Math.ceil(indicator)
                }
                let lastPageSize = result.data.subscribers.data.length % this.state.pageSize;
                if (lastPageSize === 0) {
                    lastPageSize = this.state.pageSize
                }

                if (lastPageSize === 0) {
                    lastPageSize = await this.state.pageSize
                }
                if (indicator === this.state.currentPage || indicator < 1) {
                    lastPage = true
                }
                //console.log('indicator after: ', indicator);
                if (result.data.subscribers.data.length === 0) {
                    lastPage = true;
                    lastPageSize = 0;
                }
                await this.setState({
                    searched_subscribers: result.data.subscribers.data,
                    last_page_size: lastPageSize,
                    lastPage: lastPage
                })
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        } else {
            this.setState({

                currentPage: 1,
                checkedSubscribers: []
            });

            //document.querySelector('.table-checkmark:after').css('opacity','0')
            try {
                this.setState({loader: true});
                const selected_source = this.props.selected_source || JSON.parse(localStorage.source_clicked) || this.state.selected_source;
                const pageSize = this.state.pageSize;
                // ReactGA.event({
                //     category: 'Click',
                //     action: 'Dashboard Subscribers Filter',
                //     userId: getCurrentUserId(),
                //     label: this.state.type_of_subscription,
                //     nonInteraction: true
                // });
                const type = this.state.type_of_subscription || "all";
                let type_to_get = ''
                if (this.state.selectedType === 'fb') {

                    type_to_get = "fb";
                    if (type === "daily") {
                        type_to_get = "fb_daily";
                    } else if (type === "immediate") {
                        type_to_get = "fb_immediate";
                    } else if (type === "weekly") {
                        type_to_get = "fb_weekly";
                    } else if (type === "unsubscribed") {
                        type_to_get = "fb_unsubscribed";
                    }
                } else {
                    type_to_get = 'wp'
                }

                const result = await http.get('api/feed/' + selected_source + '/subscribers/' + type_to_get + '/page_size/' + pageSize, {headers: {authorization: authService.getJwt()}});

                const data = result.data;
                let filtered = await data.subscribers.data;
                if (type !== 'unsubscribed' && type !== 'all') {
                    filtered = filtered.filter(f => f.unsubscribe !== 1)
                }
                let indicator = filtered.length / this.state.pageSize;
                //console.log('indicator:', indicator);
                if (indicator % 1 !== 0) {
                    indicator = Math.ceil(indicator)
                }
                let lastPageSize = filtered.length % this.state.pageSize;
                if (lastPageSize === 0) {
                    lastPageSize = this.state.pageSize
                }
                if (filtered.length === 0) {
                    indicator = 1;
                    lastPageSize = 0;
                }

                //  console.log('type of subscription:', type)
                await this.setState({
                    last_page_size: lastPageSize,
                    last_page: indicator === 1,
                    subscribers: filtered,
                    searched_subscribers: filtered,
                    total_subscribers: data.total_subscribers,
                    loader: false,
                    //subscription_filter: type_of_subscription.target.id
                });
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }
        //console.log(document.querySelector('.bp3-input-ghost').value);
        //console.log('ghost input element: ', document.querySelector('.bp3-input-ghost'));
        await document.querySelector('.bp3-input-ghost').setAttribute("value", " ");
        //console.log(document.querySelector('.bp3-input-ghost').value);
    };

    filterTags = (item) => {

        //console.log('filter item:', item);

        return this.props.tags.filter((t) => {
            return t.tag.toLowerCase().includes(item.toLowerCase());
        });
    };

    tagRender = (item) => {


        // console.log('tag render item:', item);
        // console.log('')
        return (
            <Tag key={item.id}>{item.tag}</Tag>
        )
        // console.log('tag render end');
    };

    handleTagRemove = async (item) => {
        let selected_source = this.state.selected_source;
        let pageSize = this.state.pageSize;
        let currentPage = this.state.currentPage;

        const type = this.state.type_of_subscription || "all";
        let type_to_get = ''
        if (this.state.selectedType === 'fb') {

            type_to_get = "fb";
            if (type === "daily") {
                type_to_get = "fb_daily";
            } else if (type === "immediate") {
                type_to_get = "fb_immediate";
            } else if (type === "weekly") {
                type_to_get = "fb_weekly";
            } else if (type === "unsubscribed") {
                type_to_get = "fb_unsubscribed";
            }
        } else {
            type_to_get = 'wp'
        }

        let selectedTagsIds = [];
        //console.log('tag select item:', item);
        const selectedTags = this.state.selectedTags;


        // console.log('selected tags:', selectedTags);
        // console.log('item', item);
        // console.log('itemId:', item.key);

        const newTags = await selectedTags.filter(t => t.tag !== item.props.children);

        newTags.map(tag => {
            selectedTagsIds = [...selectedTagsIds, tag.id]
        });

        //console.log('newTags: ', newTags);
        //console.log('selectedTagsIds -  remove: ', selectedTagsIds);

        await this.setState({selectedTags: newTags});
        if (selectedTagsIds.length > 0) {
            try {
                let result = await http.post('api/source/' + selected_source + '/filter_subscriber_tags/type/' + type_to_get + '/page_size/' + pageSize + '?page=' + currentPage
                    , {
                        tag_ids: selectedTagsIds
                    },
                    {
                        headers: {
                            authorization: authService.getJwt()
                        }
                    }
                );
                await this.setState({
                    searched_subscribers: result.data.subscribers.data
                });
                //console.log('subs filter by tags result:', result.data.subscribers.data);
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        } else {
            this.setState({

                currentPage: 1,
                checkedSubscribers: []
            });

            //document.querySelector('.table-checkmark:after').css('opacity','0')
            try {
                this.setState({loader: true});
                const selected_source = this.props.selected_source || JSON.parse(localStorage.source_clicked) || this.state.selected_source;
                const pageSize = this.state.pageSize;
                // ReactGA.event({
                //     category: 'Click',
                //     action: 'Dashboard Subscribers Filter',
                //     userId: getCurrentUserId(),
                //     label: this.state.type_of_subscription,
                //     nonInteraction: true
                // });
                const type = this.state.type_of_subscription || "all";
                let type_to_get = ''
                if (this.state.selectedType === 'fb') {

                    type_to_get = "fb";
                    if (type === "daily") {
                        type_to_get = "fb_daily";
                    } else if (type === "immediate") {
                        type_to_get = "fb_immediate";
                    } else if (type === "weekly") {
                        type_to_get = "fb_weekly";
                    } else if (type === "unsubscribed") {
                        type_to_get = "fb_unsubscribed";
                    }
                } else {
                    type_to_get = 'wp'
                }

                const result = await http.get('api/feed/' + selected_source + '/subscribers/' + type_to_get + '/page_size/' + pageSize, {headers: {authorization: authService.getJwt()}});

                const data = result.data;
                let filtered = await data.subscribers.data;
                if (type !== 'unsubscribed' && type !== 'all') {
                    filtered = filtered.filter(f => f.unsubscribe !== 1)
                }
                let indicator = filtered.length / this.state.pageSize;
                //console.log('indicator:', indicator);
                if (indicator % 1 !== 0) {
                    indicator = Math.ceil(indicator)
                }
                let lastPageSize = filtered.length % this.state.pageSize;
                if (lastPageSize === 0) {
                    lastPageSize = this.state.pageSize
                }
                if (filtered.length === 0) {
                    indicator = 1;
                    lastPageSize = 0;
                }

                //  console.log('type of subscription:', type)
                await this.setState({
                    last_page_size: lastPageSize,
                    last_page: indicator === 1,
                    subscribers: filtered,
                    searched_subscribers: filtered,
                    total_subscribers: data.total_subscribers,
                    loader: false,
                    //subscription_filter: type_of_subscription.target.id
                });
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }
    };


    handleSelectAll = async (e) => {
        //console.log('handle select all');
        //console.log('clicked element:', e.currentTarget);
        if (e.currentTarget.classList.contains('clear')) {
            let onlyIds = [];
            let allSubs = this.state.searched_subscribers;
            //console.log('all subs:', allSubs);
            allSubs.map(sub => {

                    onlyIds.push(sub.id);
                }
            );
            //console.log('onlyIds', onlyIds);
            await this.setState({checkedSubscribers: onlyIds, selectAllChecked: true})
        } else {
            await this.setState({checkedSubscribers: [], selectAllChecked: false})
        }
        this.reloadBulkActions();

    }
    ;

    handleBulkAction = async (e, id) => {

        // ReactGA.event({
        //     category: 'Click',
        //     action: 'Subscribers - Checked/Unchecked Tag',
        //     userId: getCurrentUserId(),
        //     label: '',
        //     nonInteraction: true
        // });

        // console.log('bulk actions value:', e.target);
        // console.log('tag id: ', id);
        this.setState({createTagString: ''});

        let selected_source = this.state.selected_source;
        let data = [];
        let pageSize = this.state.pageSize;
        let currentPage = this.state.currentPage;
        document.querySelector('#find-tag').setAttribute('value', '');
        let typeOfCheckbox = '';
        if (e === '') {
            typeOfCheckbox = 'clear'
        } else if (e.target.classList.contains('clear')) {
            typeOfCheckbox = 'clear'

        } else if (e.target.classList.contains('half')) {
            typeOfCheckbox = 'half'
        } else {
            typeOfCheckbox = 'full'
        }
        //console.log(
        //     'type of chekcbox:', typeOfCheckbox
        // )
        const type = this.state.type_of_subscription || "all";
        let type_to_get = ''
        if (this.state.selectedType === 'fb') {

            type_to_get = "fb";
            if (type === "daily") {
                type_to_get = "fb_daily";
            } else if (type === "immediate") {
                type_to_get = "fb_immediate";
            } else if (type === "weekly") {
                type_to_get = "fb_weekly";
            } else if (type === "unsubscribed") {
                type_to_get = "fb_unsubscribed";
            }
        } else {
            type_to_get = 'wp'
        }
        //Adding tag to all selected subscribers
        if (typeOfCheckbox === 'clear') {
            // console.log('add tag')

            try {
                await this.setState({bulkLoader: true});

                //console.log('id :', id);
                //console.log('subscriber ids:', this.state.checkedSubscribers);
                //console.log('clear call:', 'api/source/' + selected_source + '/subscriber_tags/type/' + type_to_get + '/page_size/' + pageSize + '?page=' + currentPage);
                let result = await http.post('api/source/' + selected_source + '/subscriber_tags/type/' + type_to_get + '/page_size/' + pageSize + '?page=' + currentPage
                    , {
                        tag_ids: [id], subscriber_ids: this.state.checkedSubscribers
                    }, {headers: {authorization: authService.getJwt()}});
                //console.log('clear response: ', result);
                data = await result.data.subscribers.data;

                await this.setState({bulkLoader: false});
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }


            //Adding tag to selected subscribers which doesn't have that tag
        } else if (typeOfCheckbox === 'half') {
            await this.setState({bulkLoader: true});

            //console.log('add tags to ones which doesnt have it ')
            //console.log('bulk tag id', id);
            let bulkTag = this.state.bulkTags.find(tag => tag.id === id);
            //console.log('bulkTag  subs:', bulkTag);
            try {
                // console.log('id :', id);
                // console.log('subscriber ids:', this.state.checkedSubscribers);
                let result = await http.post('api/source/' + selected_source + '/subscriber_tags/type/' + type_to_get + '/page_size/' + pageSize + '?page=' + currentPage
                    , {
                        tag_ids: [id], subscriber_ids: bulkTag.checkedSubsWithoutTag
                    }, {headers: {authorization: authService.getJwt()}});

                data = result.data.subscribers.data;
                //console.log('partial response: ', data);
                await this.setState({bulkLoader: false});

            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }

            //Removing tag from all selected subscribers
        } else {
            //console.log('remove tag')
            try {
                await this.setState({bulkLoader: true});

                //console.log('id :', id);
                //console.log('subscriber ids:', this.state.checkedSubscribers);
                let result = await http.post('api/source/' + selected_source + '/subscriber_tags_remove/type/' + type_to_get + '/page_size/' + pageSize + '?page=' + currentPage
                    , {
                        tag_ids: [id], subscriber_ids: this.state.checkedSubscribers
                    }, {headers: {authorization: authService.getJwt()}});

                data = result.data.subscribers.data;
                //console.log('remove response: ', data);
                await this.setState({bulkLoader: false});

            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    toastr.error("Something went wrong... Please refresh and try again.");
                if (ex.response && ex.response.status === 401) {
                    toastr.error(ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }
        this.setState({
            subscribers: data,
            searched_subscribers: data
        });
        this.reloadBulkActions()
    }
    ;


    reloadBulkActions = async () => {
        let checkedSubscribers = this.state.checkedSubscribers;
        //console.log('checkedSubscribers:', checkedSubscribers);
        let allTags = [...this.props.tags];
        let bulkTags = [];
        allTags.map(
            tag => {
                let newTag = {
                    id: tag.id,
                    name: tag.tag,
                    subsCount: 0,
                    checkedSubsWithoutTag: []
                };
                bulkTags = [...bulkTags, newTag]
            }
        );
        checkedSubscribers.map(checkedSub => {
                //console.log('checked sub:', checkedSub);
                let fullCheckedSub = this.state.searched_subscribers.filter(sub => sub.id === checkedSub);
                //console.log('full checked sub', fullCheckedSub)
                let checkedSubTags = fullCheckedSub[0].tags
                //console.log('checked sub tags:', checkedSubTags)
                allTags.map(async tag => {


                        // console.log('checked subscriber: ', checkedSub)
                        const matchedTags = checkedSubTags.filter(subTag => subTag.tag === tag.tag);




                        //if checked user has tags
                        if (matchedTags.length > 0) {
                            let specificTag = bulkTags.find(bulkTag => bulkTag.name === tag.tag);
                            //console.log('specific tag:',specificTag);
                            specificTag.subsCount = specificTag.subsCount + 1;
                            let otherTags = bulkTags.filter(bulkTag => bulkTag.name !== tag.tag);
                            otherTags = [...otherTags, specificTag];
                            bulkTags = otherTags;
                            //console.log('bulk tags after all:', bulkTags);
                        }
                        //if checked user doesn't have tags
                        else {
                            //console.log('doesnt have tag: ', tag.tag)
                            let specificTag = bulkTags.find(bulkTag => bulkTag.name === tag.tag);
                            let otherTags = bulkTags.filter(bulkTag => bulkTag.name !== tag.tag);
                            specificTag.checkedSubsWithoutTag.push(checkedSub);
                            otherTags = [...otherTags, specificTag];
                            bulkTags = otherTags;

                        }
                    }
                );

            }
        );
        //console.log('bulkTags:', bulkTags);
        await this.setState({bulkTags, searchedBulkTags: bulkTags});
    };

    handleCreateAddTag = async (e) => {
        let createTagString = e || this.state.createTagString;

        // console.log('handleCreateAddTag: ', createTagString)
        if (createTagString === '') {
            toastr.error("Please add a tag name to create a tag!");
            document.querySelector('#find-tag').focus()
        } else {
            let tagExists = this.state.bulkTags.filter(bulkTag => bulkTag.name === createTagString);
            // console.log('tagExists let: ',);

            if (tagExists.length > 0) {
                toastr.error("This tag already exists! Please choose a different tag name.");

            } else {
                await this.setState({createTagLoader: true})
                await this.props.handleCreateTag(createTagString);
                await this.props.handleGetTags();
                //console.log('props tags:', this.props.tags);
                this.handleBulkAction('', this.props.tags[0].id);
                toastr.success("You have successfully created and assigned tag!");
                await this.setState({createTagLoader: false})
            }
        }

    };

    noMessengerSubscribersRenderer = () => {
        return <div className='no-contacts-container panel-container margin-top-20'>
            <img src="/img/emptyStates/no-contacts-image.gif"/>
            <h3>There are no subscribers matching this criteria.</h3>
            <div className='flex-direction-row justify-content-center'>
                <button
                    onClick={() => this.props.history.push('/new/acquire-subscribers')}
                    className=' btn-action margin-bottom-10'>
                    Acquire Messenger Subscribers
                </button>
            </div>
        </div>
    };

    noWebpushSubscribersRenderer = () => {
        return <div className='no-contacts-container panel-container margin-top-20'>
            <img src="/img/emptyStates/no-contacts-image.gif"/>
            <h3>There are no subscribers matching this criteria.</h3>
            <div className='flex-direction-row justify-content-center'>
                <a href="https://help.emitto.io/en/articles/4614603-how-do-i-get-webpush-subscribers-from-my-website"
                   target="_blank">
                    <button className=' btn-action margin-bottom-10'>
                        Get Web Push subscribers
                    </button>
                </a>
            </div>
        </div>
    };

    multiMenuItem = (item,
                     {
                         modifiers, handleClick
                     }
    ) => {
        if (this.state.selectedTags.includes(item) === false) {
            return (

                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    query=''
                    shouldDismissPopover={true}

                />
            )
        } else {
            return (
                <MenuItem
                    className='multiselect-menu-item'
                    icon='small-tick'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    shouldDismissPopover={true}
                />
            )
        }
    }

    tableLoaderRenderer = () => {
        return <div className='table-loader-container'>
            <ChartLoader/>
        </div>
    }

    getMuiTheme = () => createTheme(Theme)

    handleRowsPerPageChange = async (number) => {
        let pageSize = parseInt(number)
        let userId = await this.props.userId;
        let selectedSource = await this.props.selected_source;

        let currentPage = this.state.currentPage;

        const type = this.state.type_of_subscription || "all";
        let type_to_get = ''
        if (this.state.selectedType === 'fb') {

            type_to_get = "fb";
            if (type === "daily") {
                type_to_get = "fb_daily";
            } else if (type === "immediate") {
                type_to_get = "fb_immediate";
            } else if (type === "weekly") {
                type_to_get = "fb_weekly";
            } else if (type === "unsubscribed") {
                type_to_get = "fb_unsubscribed";
            }
        } else {
            type_to_get = 'wp'
        }
        if (pageSize !== 0) {
            await this.setState({pageSize, loader: true});
            let result = await http.post('api/source/' + selectedSource + '/filter_subscriber_tags/type/' + type_to_get + '/page_size/' + pageSize + '?page=' + currentPage
                , {
                    tag_ids: this.state.selectedTagsIds
                },
                {
                    headers: {
                        authorization: authService.getJwt()
                    }
                }
            );

            await this.setState({
                searched_subscribers: result.data.subscribers.data,
                total_subscriber: result.data.total_subscriber,
                currentPage: 1,
                loader: false
            })
        }
    };

    handleSortSubscribers = async (sortData) => {
        this.setState({rowsSelected: []})
        let userId = await this.props.userId;
        let selectedSource = await this.props.selected_source;
        let columnName = sortData.name;
        let direction = sortData.direction;

        const type = this.state.type_of_subscription || "all";
        let type_to_get = ''
        if (this.state.selectedType === 'fb') {

            type_to_get = "fb";
            if (type === "daily") {
                type_to_get = "fb_daily";
            } else if (type === "immediate") {
                type_to_get = "fb_immediate";
            } else if (type === "weekly") {
                type_to_get = "fb_weekly";
            } else if (type === "unsubscribed") {
                type_to_get = "fb_unsubscribed";
            }
        } else {
            type_to_get = 'wp'
        }

        try{
            let result = await http.post('api/source/' + selectedSource + '/filter_subscriber_tags/type/' + type_to_get + '/page_size/' +
                this.state.pageSize + '?page=' + 1 + '&order=' + direction + '&sort=' + columnName
                , {
                    tag_ids: this.state.selectedTagsIds
                },
                {
                    headers: {
                        authorization: authService.getJwt()
                    }
                }
            );


            await this.setState({
                searched_subscribers: result.data.subscribers.data,
                total_subscriber: result.data.total_subscriber,
                currentPage: 1,
                loader: false
            })
        }catch{
            toastr.error('Error with searching contacts')
        }
    }

    render() {
        const { type_of_subscription, selected_source, max_subscribers, } = this.state;


        if (!selected_source) {
            return <React.Fragment>
                <div className="display-flex">
                    <h1 className='main-title'>Subscribers</h1>
                </div>

                <div className="row">
                    <div className="col-xs-12 text-center no-feeds-containers">
                        <div className="feed-msg">
                            <img className='emitto-mark' src="/img/emitto-mark.png" alt="Emitto Mark"/>
                            <p className="text-center ">{authService.getCurrentUserName()}</p>
                            <p>It looks like you haven't set up any workspaces yet. Add your first workspace, and
                                start
                                growing
                                your audience.</p>
                            <img className='cat-img' src="/img/cat-transparent.gif" alt="No Workspaces"/>
                        </div>
                        <button className='btn-m btn-action' onClick={this.props.addSource} type="button">
                            Create your first workspace
                        </button>
                    </div>
                </div>
            </React.Fragment>
        }


        //console.log("subscribers subscribers subscribers ", subscribers);
        //all columns are fixed except the last one which is dynamically calculated to fill the rest of the available screen width


        const pushColWidth = (window.screen.width - 440) / 9;
        //console.log('pushColWidth:', pushColWidth);
        const pushColsWidth = [50, pushColWidth, pushColWidth, pushColWidth, pushColWidth, pushColWidth, pushColWidth, pushColWidth, pushColWidth, pushColWidth];

        const columnsMessenger = [
            {
                name: "name",
                label: "Subscriber",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.searched_subscribers[tableMeta.rowIndex];
                        const facebook_app_graph_url = process.env.REACT_APP_FB_URL;

                        return <div className='mui-column-wrapper col-subscribers-name'>
                            <img
                                src={facebook_app_graph_url + item.fb_id_subscriber + "/picture?type=square&access_token=" + item.page_tok
                                || "/img/user-default.jpg"} alt={item.subscriber_name || 'Default user'}
                                onError={this.addDefaultSrc}/> {item.subscriber_name}
                        </div>
                    }
                }
            },
            {
                name: "tags",
                label: "Tags",
                options: {
                    filter: true,
                    filterOptions: {
                        names: this.state.tagsNames,
                        logic: (tags, checkedTags, row) => {
                            if (checkedTags.length && row[3].length && row[3].some(tag => checkedTags.includes(tag.tag))) {
                                return false;
                            } else {
                                return true;
                            }
                        },
                    },
                    filterType: 'checkbox',
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        // console.log('tableMeta: ', tableMeta)
                        const item = this.state.searched_subscribers[tableMeta.rowIndex];
                        return item.tags ? item.tags.map(tag =>
                                    <Tag key={tag.tag} className='table-tag margin-vertical-5 margin-right-5'>
                                        {tag.tag}
                                    </Tag>
                                ) : ''

                    }
                }
            },
            {
                name: "subscription",
                label: "Subscription",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        // console.log('tableMeta: ', tableMeta)
                        const item = this.state.searched_subscribers[ tableMeta.rowIndex ];
                        let subscription = '';
                        if(item.hasOwnProperty('unsubscribe') && item.unsubscribe === 1){
                            subscription = 'unsubscribed';
                        } else {
                            subscription = item.type_of_subscription
                        }
                        return <div className={ 'sub-type ' + subscription }>
                            { subscription }
                        </div>
                    }
                }
            },
            {
                name: "timezone",
                label: "Timezone",
                options: {
                    filter: false,
                    sort: false,
                }
            },
            {
                name: "created_at",
                label: "Registered",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.searched_subscribers[ tableMeta.rowIndex ];
                        let dateConverted = item.created_at ? this.props.isodateToDate(item.created_at) : ''

                        return <div className='mui-column-wrapper'>
                            {dateConverted}
                        </div>
                    }
                }
            },
            {
                name: "page",
                label: "Susbscribed page",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.searched_subscribers[ tableMeta.rowIndex ];
                        return <div className='mui-column-wrapper'>
                        <p><span className="fab fa-facebook-messenger"></span> {item.page_name}</p>
                        </div>
                    }
                }
            },
        ];

        const columnsWebPush = [
            {
                name: "id",
                label: "Subscriber ID",
                options: {
                    filter: false,
                    sort: true,
                }
            },
            {
                name: "tags",
                label: "Tags",
                options: {
                    filter: true,
                    filterOptions: {
                        names: this.state.tagsNames,
                        logic: (tags, checkedTags, row) => {
                            if (checkedTags.length && row[3].length && row[3].some(tag => checkedTags.includes(tag.tag))) {
                                return false;
                            } else {
                                return true;
                            }
                        },
                    },
                    filterType: 'checkbox',
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        // console.log('tableMeta: ', tableMeta)
                        return value.length ? value.map(tag => <div className='margin-vertical-5 margin-right-5'>
                            <Tag
                                className={['custom-tag', tag.tag.toLowerCase() === 'immediate' ? 'bp3-intent-primary' : tag.tag.toLowerCase() === 'daily' ?
                                    'bp3-intent-success' : tag.tag.toLowerCase() === 'weekly' ? 'bp3-intent-warning' :
                                        tag.tag.toLowerCase() === 'weekly' ? 'bp3-intent-darkblue' : '']}
                                key={tag.tag}
                            >
                                {tag.tag.toLowerCase()}
                            </Tag>
                        </div>) : ''
                    }
                }
            },
            {
                name: "created_at",
                label: "Registered",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.searched_subscribers[ tableMeta.rowIndex ];
                        let dateConverted = item.created_at ? this.props.isodateToDate(item.created_at) : ''

                        return <div className='mui-column-wrapper'>
                            {dateConverted}
                        </div>
                    }
                }
            },
            {
                name: "last_active",
                label: "Last Active",
                options: {
                    filter: false,
                    sort: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.searched_subscribers[ tableMeta.rowIndex ];
                        let dateConverted = item.last_active ? this.props.isodateToDate(item.last_active) : ''

                        return <div className='mui-column-wrapper'>
                            {dateConverted}
                        </div>
                    }
                }
            },
            {
                name: "user_browser",
                label: "User Browser",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.searched_subscribers[tableMeta.rowIndex];
                        let browser =  '';
                        if(item.origin !== [] && item.origin !== null && item.origin){
                            if(item.origin.app !== undefined){
                                browser = item.origin.app
                            } else {
                                browser = ''
                            }
                        }
                        return browser
                    }
                }
            },
            {
                name: "os",
                label: "OS",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.searched_subscribers[tableMeta.rowIndex];
                        let os =  '';
                        if(item.origin !== [] && item.origin !== null && item.origin){
                            if(item.origin.OS){
                                os = item.origin.OS
                            } else {
                                os = ''
                            }
                        }
                        return os
                    }
                }
            },
            {
                name: "timezone",
                label: "Timezone",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.searched_subscribers[tableMeta.rowIndex];
                        let timeZone =  '';
                        let offset = item.origin ? String(item.origin.timezoneOffset) : '';
                        let name = item.origin ? item.origin.timezoneName : '';

                        // {offset.charAt(0) === '-' ? offset : '+' + offset} ({'' + name})

                        if(item.origin !== [] && item.origin !== null && item.origin){

                            timeZone = name ? name + ' ' + offset : ''
                        }
                        return timeZone
                    }
                }
            },
            {
                name: "country",
                label: "Country",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.searched_subscribers[tableMeta.rowIndex];

                        return item.origin && item.origin.countryFlag ?
                            <div className='mui-column-wrapper min-width-80'>
                                <img className='country-flag' src={item.origin.countryFlag} alt={item.origin.country}/>
                                {item.origin.country}
                            </div>
                            :
                            <div/>
                    }
                }
            },
            {
                name: "city",
                label: "City",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        const item = this.state.searched_subscribers[tableMeta.rowIndex];
                        let os =  '';

                        return item.origin && item.origin.city ? item.origin.city : ''
                    }
                }
            },
        ];

        const options = {
            // customSearch: (searchQuery, currentRow, columns) => console.log('customSearch: ', searchQuery, currentRow, columns),
            onSearchChange: (text) => this.handleSearchContacts(text),
            onSearchClose: this.handleSearchContactsClose,
            searchText: this.state.searchTerm,
            // customSort: (data, colIndex, order, meta) => {
            //     console.log('customSort: ', data, colIndex, order, meta)
            // },
            // onFilterChange: (changedColumn, filterList, type, changedColumnIndex, displayData) => {console.log('onFilterChange:', changedColumn, filterList, type, changedColumnIndex, displayData)},
            // customSearchRender: (searchText, handleSearch, hideSearch, options) => console.log('customSearchRender: ', searchText, handleSearch, hideSearch, options),
            serverSide: true,
            count: this.state.total_subscribers,
            filterType: 'checkbox',
            rowsPerPage: this.state.pageSize,
            print: false,
            search: false,
            filter: false,
            sort: true,
            download: false,
            onChangeRowsPerPage: (number) => this.handleRowsPerPageChange(number),
            page: this.state.currentPage - 1,
            rowsPerPageOptions: [10, 25, 50, 100],
            rowsSelected: this.state.rowsSelected,
            textLabels: {
                body: {
                    noMatch: this.state.loader ?
                        this.tableLoaderRenderer()
                        :
                        'Sorry, there is no matching data to display',
                },
            },
            onTableChange: (action, tableState) => {
                // console.log(action, tableState);

                // a developer could react to change on an action basis or
                // examine the state as a whole and do whatever they want

                switch (action) {
                    case 'changePage':
                        this.handlePageChange(tableState.page + 1);
                        break;
                    case 'sort':
                        this.handleSortSubscribers(tableState.sortOrder)
                        break;
                    // default:
                    //     console.log('action not handled.');
                }
            },
            downloadOptions: {
                filename: 'emittoContactsDownload.csv',
                separator: ',',
                filterOptions: {
                    useDisplayedColumnsOnly: true
                }
            },
            customToolbarSelect: (selectedRows, displayData, setSelectedRows) => (
                <CustomToolbarSelect
                    selectedRows={selectedRows}
                    displayData={displayData}
                    setSelectedRows={setSelectedRows}
                    createTagString={this.state.createTagString}
                    checkedContacts={this.state.checkedSubscribers}
                    bulkTags={this.state.bulkTags}
                    searchedBulkTags={this.state.searchedBulkTags || []}
                    bulkLoader={this.state.bulkLoader}
                    handleDeleteContacts={() => this.setState({deleteSubscribersModalVisible: true})}
                    handleDeleteAllContacts={ () => this.setState({deleteAllContactsModalActive: true})}
                    allContactsChecked={ this.state.allContactsChecked }
                    handleCreateAddTag={this.handleCreateAddTag}
                    handleBulkAction={this.handleBulkAction}
                    handleTagSearch={this.handleTagSearch}
                    createTagLoader={this.state.createTagLoader}
                    bulkIsOpen={this.state.bulkIsOpen}
                />
            ),
            onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
                this.setState({rowsSelected});
                this.handleCheck(rowsSelected)
                //console.log('currentRowsSelected: ', currentRowsSelected, ' allRowsSelected:', allRowsSelected, ' rowsSelected:', rowsSelected)
            }

        };

        return (
            <React.Fragment>

                {/*{console.log('tags:', this.props.tags)}*/}
                <h1 className='main-title' id="subscribers">Subscribers</h1>
                {/*{console.log('type of subscription: ', type_of_subscription)}*/}

                <div className="tabs-navigation">
                    <div id="chatbot-button"
                         className={this.state.selectedType === 'fb' ? 'navigation-tab active' : 'navigation-tab'}
                         onClick={this.toggleSubscribersType}>
                        <img src='/img/channels/messenger-icon.svg'/>
                        Messenger
                    </div>
                    <div id="webpush-button"
                         className={this.state.selectedType === 'wp' ? 'navigation-tab active' : 'navigation-tab'}
                         onClick={this.toggleSubscribersType}>
                        <img src='/img/channels/notification-icon.svg'/>
                        Webpush
                    </div>

                </div>
                <div className="separator"></div>


                <div className="subtypes-container subscribers-subtypes">

                    <div className="flex-row subs-segmentation-container">
                        <MultiSelect
                            items={this.props.tags}
                            itemRenderer={this.multiMenuItem}
                            tagInputProps={{
                                placeholder: 'Filter by tag',
                                onRemove: this.handleTagRemove
                            }}
                            resetOnSelect={true}
                            className='tag-multiselect'
                            onItemSelect={this.tagSelect}
                            tagRenderer={this.tagRender}
                            itemListPredicate={this.filterTags}
                            selectedItems={this.state.selectedTags}
                            fill={true}
                            noResults={<MenuItem disabled={true} text="No results."/>}
                        />
                        {this.state.selectedType === 'fb' ?

                            <div className="tabs-navigation">

                                <div onClick={this.switchTypeOfSubscription} id="all"
                                     className={type_of_subscription === "all" ? "navigation-tab active" : "navigation-tab "}>Show
                                    All
                                    - {max_subscribers}</div>
                                <div onClick={this.switchTypeOfSubscription} id="immediate"
                                     className={type_of_subscription === "immediate" ? "navigation-tab active" : "navigation-tab "}>
                                    Immediate
                                    - {this.state.immediate}
                                </div>
                                <div onClick={this.switchTypeOfSubscription} id="daily"
                                     className={type_of_subscription === "daily" ? "navigation-tab active" : "navigation-tab "}>Daily
                                    - {this.state.daily} </div>
                                <div onClick={this.switchTypeOfSubscription} id="weekly"
                                     className={type_of_subscription === "weekly" ? "navigation-tab active" : "navigation-tab "}>Weekly
                                    - {this.state.weekly}</div>
                                <div onClick={this.switchTypeOfSubscription} id="unsubscribed"
                                     className={type_of_subscription === "unsubscribed" ? "navigation-tab active" : "navigation-tab "}>
                                    Unsubscribed - {this.state.unsubscribed}</div>
                            </div>
                            :
                            ''

                        }
                    </div>
                </div>
                <div className='margin-bottom-10'/>
                <Switch>
                    <Route
                        path='/subscribers/messenger'
                        render={ (props) => this.state.loader ?
                            this.tableLoaderRenderer()
                            :
                            !this.state.searched_subscribers.length ?
                                <div className='subs-nodata'>
                                    {this.noMessengerSubscribersRenderer()}
                                </div>
                                :
                                <MuiThemeProvider theme={ this.getMuiTheme() }>
                                    <MUIDataTable
                                        title={ "" }
                                        data={ this.state.searched_subscribers }
                                        columns={ columnsMessenger }
                                        options={ options }
                                    />
                                </MuiThemeProvider>
                        }
                        />
                    <Route
                        path='/subscribers/web-push'
                        render={ (props) => this.state.loader ?
                            this.tableLoaderRenderer()
                            :
                            !this.state.searched_subscribers.length ?
                                <div className='subs-nodata'>
                                    {this.noWebpushSubscribersRenderer()}
                                </div>
                                :
                                <MuiThemeProvider theme={ this.getMuiTheme() }>
                                    <MUIDataTable
                                        title={ "" }
                                        data={ this.state.searched_subscribers }
                                        columns={ columnsWebPush }
                                        options={ options }
                                    />
                                </MuiThemeProvider>
                        }
                    />
                </Switch>

                <DeleteSubscribersModal
                    showModal={this.state.deleteSubscribersModalVisible}
                    saveContact={this.saveContact}
                    handleClose={() => this.setState({deleteSubscribersModalVisible: false})}
                    maxWidth={500}
                    history={this.props.history}
                    deleteSubscriberIds={this.state.checkedSubscribers}
                    pageSize={this.state.pageSize}
                    currentPage={this.state.currentPage}
                    subscribersType={this.state.selectedType}
                    selected_source={selected_source}
                    setDeleteSubscribersIndicator={this.props.setDeleteSubscribersIndicator}
                    updateUserFromServer={this.props.updateUserFromServer}
                />
            </React.Fragment>
        )
    }
}

export default sizeMe()(Subscribers);